/** @prettier */
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import GlobalBannerPortal from '@xanadu/ui-shared/components/GlobalBannerPortal';
import RedirectForLoggedOut from '@xanadu/ui-shared/components/RedirectForLoggedOut';
import async from '@xanadu/ui-shared/components/asyncComponent';

import Header from '../components/Reports/Header';

const AsyncReports = async(() =>
  import('@xanadu/ui-shared/components/reports/Reports').then((module) => module.default)
);

const AsyncAccountActivity = async(() =>
  import('@xanadu/ui-shared/components/AccountActivity').then((module) => module.default)
);

const AsyncTransactions = async(() =>
  import('@xanadu/ui-shared/components/reports/Transactions').then((module) => module.default)
);

const AsyncSettled = async(() =>
  import('@xanadu/ui-shared/components/reports/Settled').then((module) => module.default)
);

const AsyncMultiples = async(() =>
  import('@xanadu/ui-shared/components/reports/Multiples').then((module) => module.default)
);

const AsyncBetBuilder = async(() =>
  import('@xanadu/ui-shared/components/reports/BetBuilder').then((module) => module.default)
);

const AsyncCurrent = async(() =>
  import('@xanadu/ui-shared/components/reports/Current').then((module) => module.default)
);

const Reports = () => (
  <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
    <GlobalBannerPortal bigger />
    <Header />
    <RedirectForLoggedOut />
    <Route path="/reports">
      <Switch>
        <Redirect exact from="/reports/" to="/reports/settled/bets" />
        <Redirect exact from="/reports/current" to="/reports/current/bets" />
        <Redirect exact from="/reports/settled" to="/reports/settled/bets" />
        <AsyncReports>
          <Route path="/reports/account-activity" component={AsyncAccountActivity} />
          <Route path="/reports/transaction-history" component={AsyncTransactions} />
          <Route path="/reports/settled/bets" render={() => <AsyncSettled />} />
          <Route path="/reports/multiples" render={() => <AsyncMultiples />} />
          <Route path="/reports/bet-builder" render={() => <AsyncBetBuilder />} />
          <Route path="/reports/current/bets" render={() => <AsyncCurrent type="bets" />} />
          <Route path="/reports/current/offers" render={() => <AsyncCurrent type="offers" />} />
        </AsyncReports>
      </Switch>
    </Route>
  </div>
);

export default Reports;
